import { Animal, SearchRequestParams, APIErrorResponse } from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from './useQueryList'

export const useAnimals = (
  { search, ...params }: SearchRequestParams,
  enabled = true
): UseQueryResult<Animal[], APIErrorResponse> =>
  useQueryList({
    url: '/protocols/animal/',
    options: {
      enabled,
    },
    params: {
      ...params,
      ...(search ? { search } : {}),
    },
  })
